import { zodResolver } from "@hookform/resolvers/zod";
import { db } from "../firebase";
import { useForm, SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { collection, getDocs, query, where } from "firebase/firestore";
import { Puzzle } from "../models/Puzzle";
import { LevelSchema } from "../services/forms-schemas";

interface PuzzleFormProps {
    target: Puzzle | null,
    onError?(error: string): void,
    onSubmit?(data: any): void,
    onCancel?(): void,
}

export default function PuzzleForm(props: PuzzleFormProps) {

    const { target = new Puzzle() } = props;

    const { t } = useTranslation();

    type Inputs = z.infer<typeof LevelSchema>;

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors } } = useForm<Inputs>({
            resolver: zodResolver(LevelSchema)
        });

    const processForm: SubmitHandler<Inputs> = async data => {

        const objectData = {
            level: data.level,
            text: data.text,
            raw_text: data.raw_text,
            author: data.author,
            country: data.country,
            era: data.era,
        }

        if (!target && await isPriceExists(data)) {
            if (props.onError) {
                props?.onError("Duplicate Entry");
            }
            return;
        } else if (props.onSubmit) {
            props?.onSubmit(objectData);
        }

        reset();
    }

    const isPriceExists = async (data: Inputs) => {
        const pricesRef = collection(db, "puzzles");

        const rows = await getDocs(query(pricesRef,
            where("level", "==", data.level)));

        return rows.docs.length > 0;
    }

    return (
        <form className="w-100" method="post" onSubmit={handleSubmit(processForm)}>
            <Table bordered striped>
                <tbody>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("level")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter level"
                                defaultValue={target?.level}
                                {...register("level", { value: target?.level, required: true, valueAsNumber: true })}
                            />
                            {errors.level?.message && (
                                <p className="small text-danger">{errors.level.message}</p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("text")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter price (JOD)"
                                defaultValue={target?.text}
                                {...register("text", { value: target?.text, required: true })}
                            />
                            {errors.text?.message && (
                                <p className="small text-danger">{errors.text.message}</p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("raw_text")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter price (JOD)"
                                defaultValue={target?.rawText}
                                {...register("raw_text", { value: target?.rawText, required: true })}
                            />
                            {errors.raw_text?.message && (
                                <p className="small text-danger">{errors.raw_text.message}</p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("author")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter price (JOD)"
                                defaultValue={target?.text}
                                {...register("author", { value: target?.author, required: true })}
                            />
                            {errors.author?.message && (
                                <p className="small text-danger">{errors.author.message}</p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("country")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter country"
                                defaultValue={target?.country}
                                {...register("country", { value: target?.country, required: true })}
                            />
                            {errors.country?.message && (
                                <p className="small text-danger">{errors.country.message}</p>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="field-label" colSpan={2}>
                            {t("era")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input
                                className="w-100"
                                placeholder="Enter era"
                                defaultValue={target?.era}
                                {...register("era", { value: target?.era, required: true })}
                            />
                            {errors.era?.message && (
                                <p className="small text-danger">{errors.era.message}</p>
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
            <div className="mt-3 float-end">
                <Button type="submit" variant="primary" className="px-4 py-2 me-3">{t("save_button_label")}</Button>
                <Button type="button" variant="secondary" className="px-4 py-2"
                    onClick={props.onCancel}>
                    {t("cancel_button_label")}
                </Button>
            </div>
        </form >
    );
}